/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { FormControlLabel, Checkbox, FormGroup, FormControl, FormLabel, IconButton, Tooltip, Box, Typography, Button, InputLabel, Select, MenuItem, List, ListItem, ListItemText, ListItemSecondaryAction } from '@mui/material';
import { colors, fonts } from '../../../utils';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
// import { setAllPostCategories } from '../../../redux/slices/posts/posts';
import { errorNotify, successNotify } from '../../../utils/helper';
import Table from '../../../components/table/Table';
import EditIcon from '@mui/icons-material/Edit';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import moment from 'moment';
import { setAllPermissions } from '../../../redux/slices/permissions/permissions';

const styles = {
	box: {
		border: "1px solid lightgrey",
		padding: "3rem",
		width: "100%",
		marginTop: "2em",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center"
	},
	slide: {
		width: "200px",
		height: "200px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		margin: "2em",
		border: "1px solid lightgrey",
		padding: "10px"

	},
	img: {
		width: "100%",
		margin: "auto"
	},
	slider: {
		display: "flex",
		alignItems: "center",

	}

};

const RolesDialog = ({ data, handleCloseModal, isOpen, setDialogData, isEditing, type, getRoles }) => {
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary,colorGreenGradient } = colors;

	const { permissions } = useSelector((state) => state?.permissions);
	const [openDialog, setopenDialog] = useState(isOpen);
	const [currentPermissions, setCurrentPermissions] = useState(type === 'Update' ? data.permission : []);
	// const [name, setName] = React.useState(data.name);
	// const [description, setDescription] = React.useState(data.description);


	const fileInputRef = useRef(null);
	const [formData, setFormData] = useState({
		question: '',
		answer: '',
		type: '',
	});
	// const [userRules, setUserRules] = useState([]);


	const handleChange = (e) => {
		setDialogData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};



	const handleDeletePermission = async () => {

		try {

			await Api.post(endPoints?.faqs?.delete, {
				...formData
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Faq Deleted Successfully")
					handleCloseDeleteModal();
					// getPermissions();

				})
				.catch((error) => {

				});

		} catch (err) {
			console.log(err)
		}
	};



	const handleOpenDeleteModal = (val) => {
		// setFormData({ id: val.id })
		// setOpenDeleteModal(true)
	};
	const handleCloseDeleteModal = () => {
		// setFormData({ question: '', answer: '', type: '' })
		// setOpenDeleteModal(false)
	};

	const handleSubmit = async () => {
		if (!isEditing) {


			try {

				await Api.post(endPoints?.roles?.create, {
					"id": 0,
					"name": data.name,
					"description": data.description,
					"permissions": data.permission,
					"enabled": data.enabled,
					"displayed": true
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getRoles();
						successNotify("Roles Created Successfully")

					})
					.catch((error) => {

					});

			} catch (error) {
				if (error?.response?.data) {
					errorNotify(error?.response?.data?.message);
				}
			}

		} else {


			try {

				await Api.put(`${endPoints?.roles?.update}/${data?.id}`, {
					"id": data.id,
					"name": data.name,
					"description": data.description,
					"permissions": data.permission,
					"enabled": data.enabled,
					"displayed": true
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getRoles();
						successNotify("Roles Updated Successfully")

					})
					.catch((error) => {

					});

			} catch (error) {
				if (error?.response?.data) {
					errorNotify(error?.response?.data?.message);
				}
			}
		}
	};






	const handleEnable = event => {
		setDialogData(prevData => ({
			...prevData,
			enabled: event.target.checked,
		}));
		// setEnabled(event.target.checked);
	};

	const onInputChange = e => {
		let value = null;
		if (e.target.name === 'permissions') {
			const updatedPermissions = [...data.permission];

			
			const roleIndex = data.permission?.indexOf(e.target.value);
			if (roleIndex === -1) {
				// currentPermissions.push(e.target.value);
				updatedPermissions.push(e.target.value);

			} else {
				// currentPermissions?.splice(roleIndex, 1);
				updatedPermissions.splice(roleIndex, 1);

			}
			value = [...updatedPermissions];
			// value = [...currentPermissions];
			// setCurrentPermissions(value);
			setDialogData(prevData => ({
				...prevData,
				permission: value,
			}));
		} else {
			if (e.target.name === 'enabled') {
				value = e.target.checked;
			} else value = e.target.value;
		}
	};

	// useEffect(()=>{
	// 	getPermissions()
	// },[])
	return (
		<>

			<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>

				<TransitionsModal
					open={isOpen}
					handleClose={handleCloseModal}
					modalTitle={isEditing ? "Update Roles" : "Create Roles"}
				>

					<Grid gtc='repeat(auto-fit, minmax(20rem, 1fr))' >
						<Grid gtc='repeat(auto-fit, minmax(10rem, 1fr))' margin='2.5rem 0' padding='2rem'>
							<Box>
								<MarginHandler width='100%'>
									<InputControl
										state={data?.name}
										onChange={handleChange}
										// inputProps={{ maxLength: 60 }}
										label='Name'
										name='name'
										required
									/>
								</MarginHandler>
								<MarginHandler mt={"2em"} width='100%'>
									<InputControl
										state={data?.description}
										onChange={handleChange}
										// inputProps={{ maxLength: 120 }}
										label='Description'
										name='description'
										required
									/>
								</MarginHandler>


								<MarginHandler mt={"2em"} width='100%'>
									<FormControlLabel
										control={<Checkbox checked={data?.enabled} onChange={handleEnable} />}
										label="Enabled"
									/>
								</MarginHandler>
							</Box>


						</Grid>
						<Grid gtc='repeat(auto-fit, minmax(10rem, 1fr))' margin='2.5rem 0' padding='2rem'>

							<List dense>
								{permissions?.map(value => {
									const labelId = `checkbox-list-secondary-label-${value}`;
									return (
										<div key={`item_div_${Math.random()}`}>
											<ListItem key={`item_${Math.random()}`} button>
												<ListItemText key={`item_text_${Math.random()}`} id={labelId} primary={<span style={{fontSize:"1.5em"}}>{value.title}</span>} />
												<ListItemSecondaryAction key={`item_sa_${Math.random()}`} >
													<Checkbox
													sx={{
														'& .MuiSvgIcon-root': { fontSize: 22 }
														}
													  }
														key={`item_checkbox_${Math.random()}`}
														name={'permissions'}
														value={value.id}
														edge="end"
														onChange={onInputChange}
														checked={data.permission?.includes(value.id) && true}
														inputProps={{ 'aria-labelledby': labelId }}
													/>
												</ListItemSecondaryAction>
											</ListItem>
										</div>
									);
								})
								}
							</List>
						</Grid>



					</Grid>
					<Button
						color='primary'
						variant='contained'
						onClick={handleSubmit}
						style={{
							background: colorGreenGradient,
							fontSize: '1.6rem',
							textTransform: 'none',
							padding: '0.7rem 2rem',
							color: colorWhite,
							borderRadius: '0.5rem',
							float: "right",
							margin: "0em 1.5em 2em 0em"
						}}
						className='font-face-R'>
						{isEditing ? "Update " : "Create "}
					</Button>
				</TransitionsModal>
			</Flex>
		</>
	);
};

export default RolesDialog;
